export default {
	CREATE: 'CREATE',
	UPDATE: 'UPDATE',
	CANCEL: 'CANCEL',
	EDIT: 'EDIT',
	DESTROY: 'DESTROY',
};
